import { atom } from 'recoil';

export const searchTermAtom = atom({
  key: 'global-search-search-term',
  default: '',
});
